import { LoadingSection } from 'components/LoadingSection';
import { useSuspendedUIDelay } from 'hooks/useDelay';
import { Modal } from 'modals/Modal';
import { hideModal } from 'modules/main/store/ducks/modal.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';

// eslint-disable-next-line import/no-default-export
export default function LoadingModal() {
  const dispatch = useMainDispatch();
  const { pastDelay } = useSuspendedUIDelay();

  if (!pastDelay) return null;

  return (
    <Modal onClose={() => dispatch(hideModal)}>
      <LoadingSection noDelay />
    </Modal>
  );
}
